export default {
	props: {
		numSteps: Number,
		currentStep: Number,
		stepNames: Array 
	},

	computed: {
		progress () {
			return (this.currentStep / this.numSteps) * 100
		}
	},

	methods: {
		back(step) {
			if (step < this.currentStep) {
				this.$router.push('/booking/' + step);
			}
		}
	}

}


// WEBPACK FOOTER //
// ./src/components/donate/progress-steps/progress-steps.js